var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNewspaper = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.8 58.8",
    style: {
      enableBackground: "new 0 0 58.8 58.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#A32F88;stroke-width:3.49;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{fill:none;stroke:#A32F88;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,50.7c-3.5,0-6.3-2.8-6.3-6.3V8.7h41.5v35.7c0,3.5,2.8,6.3,6.3,6.3s6.3-2.8,6.3-6.3V22.5h-6.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.4,
    y1: 50.7,
    x2: 48.9,
    y2: 50.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 25.5,
    className: "st0",
    width: 12.3,
    height: 16.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 35.2,
    y1: 17.2,
    x2: 10.2,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 35.2,
    y1: 25.5,
    x2: 29.3,
    y2: 25.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 35.2,
    y1: 33.9,
    x2: 29.3,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 35.2,
    y1: 42.2,
    x2: 29.3,
    y2: 42.2
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewspaper, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/newspaper.f4d9c2ff.svg";
export { ForwardRef as ReactComponent };